import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackInitiateCheckout } from '../../utils/metaPixel';
import { pricingRows, pricingTrustItems, pricingIncludes } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-white py-14 sm:py-16" data-id="element-161" data-mp="3lh4hyizb8d0p">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-162" data-mp="3pj7yvn4r09td">
        <SectionTag icon="💰" data-id="element-163" data-mp="3plkjy95sz0an">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-164" data-mp="3ujm6j42fthqv">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-gris-texto sm:text-lg" data-id="element-165" data-mp="204te1dwup735">Acceso inmediato y garantía total de 7 días.</p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-6 sm:px-8" data-id="element-166" data-mp="254pe522fgedf">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-2xl border-2 border-naranja bg-bg-secondary p-6 shadow-leve sm:p-7" data-id="element-167" data-mp="1baqepvnx817m">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-gris-muted" data-id="element-168" data-mp="11iklkilxndqu">
            Balonmano Pro 360: La Pizarra del Entrenador
          </p>
          <p className="mt-1.5 text-xs text-gris-muted" data-id="element-169" data-mp="1u92qzqa4pr7f">6 tomos + 5 bonos, listos para llevar a la pista.</p>

          <ul className="mt-3 space-y-1.5 text-left" data-id="element-170" data-mp="1pbazuyhb694a">
            {pricingIncludes.map(item => <li key={item} className="flex items-start gap-2 text-xs leading-relaxed text-gris-texto" data-id="element-171" data-mp="1lb0t3jlozeod">
                <CheckIcon size={13} className="mt-0.5 flex-shrink-0 text-verde" aria-hidden="true" data-id="element-172" data-mp="1gbxp82hg7ehz" />
                <span data-id="element-173" data-mp="9rej3viqp3ye">{item}</span>
              </li>)}
          </ul>

          <div className="mt-4 space-y-1.5" data-id="element-174" data-mp="4td17dx1vaoi">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-gris-claro py-1.5 text-sm" data-id="element-175" data-mp="6ccyfzgoyl7k">
                <span className="text-gris-texto" data-id="element-176" data-mp="3tfht8nyl9usf">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-177" data-mp="1cgw04nn71u4">
                  <span className="text-gris-texto" data-id="element-178" data-mp="1el9nebcff7l">{row.value}</span>
                  <CheckIcon size={14} className="text-verde" aria-hidden="true" data-id="element-179" data-mp="3jp5a906fa9oe" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-marino" data-id="element-180" data-mp="39sk42bio2siz">
              <span data-id="element-181" data-mp="3ern0x8ohtsfv">VALOR TOTAL</span>
              <span className="text-rojo line-through" data-id="element-182" data-mp="3esoky2nhlp9q">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-gris-muted" data-id="element-183" data-mp="30t6s9c72lrv3">Precio hoy (88% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-marino sm:text-6xl" data-id="element-184" data-mp="35png05acy47n">13,99€</p>
          <span className="mt-2 inline-block rounded-full bg-naranja-light px-3 py-1 text-sm font-semibold text-black" data-id="element-185" data-mp="2m683jozllbk2">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <div className="mt-6" data-id="element-186" data-mp="2v63j0606rspw">
            <PrimaryButton href={CHECKOUT_URL} onClick={trackInitiateCheckout} fullWidth data-id="element-187" data-mp="2v7em03lt4wfy">
              Quiero Balonmano Pro 360 por 13,99€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-gris-muted" data-id="element-188" data-mp="352q2orgs0dqc">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-189" data-mp="3etkqi09o7ldw">
                <item.icon size={12} data-id="element-190" data-mp="3evx3dz0kn5k3" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}